// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XQE6ZvV6qGW2VX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
}
.jcvEMgHOJqyWjm {
  width: 20px;
  height: 20px;
}
.bf0uSMLyq3kEja {
  width: 24px;
  height: 24px;
}
.rQFwM4HIGge6IR {
  width: 32px;
  height: 32px;
}
.LClDQeRPf9Fv1Y {
  width: 40px;
  height: 40px;
}
.QgTmUON8ffYspP {
  width: 44px;
  height: 44px;
}
.dFtpAN_NM7oDxM {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.kLjZy6hG3ATQTS {
  filter: brightness(60%) sepia(1) hue-rotate(180deg) saturate(100.5%) brightness(125%) contrast(1.2);
  background-color: var(--ds-background-neutral-bold, #42526e);
}
`, ""]);
// Exports
export var logoContainer = `XQE6ZvV6qGW2VX`;
export var xxsmallLogoContainer = `jcvEMgHOJqyWjm`;
export var xsmallLogoContainer = `bf0uSMLyq3kEja`;
export var smallLogoContainer = `rQFwM4HIGge6IR`;
export var mediumLogoContainer = `LClDQeRPf9Fv1Y`;
export var largeLogoContainer = `QgTmUON8ffYspP`;
export var workspaceLogo = `dFtpAN_NM7oDxM`;
export var desaturateLogo = `kLjZy6hG3ATQTS`;
export default ___CSS_LOADER_EXPORT___;
